import { BrowserRouter, Routes, Route, Navigate, useNavigate } from "react-router-dom"
import api, { setApiNavigator } from "./api";
import Register from './pages/Register';
// import Home from './pages/Home';
// import NotFound from './pages/Notfound';
import ProtectedRoute from "./components/ProtectedRoute"
import Landing from './pages/Landing';
import Settings from "./pages/Settings";
import { UserProvider } from './UserContext';
import ForgetPassword from "./pages/ForgetPassword";
import Profile from "./pages/Profile";
import Search from "./pages/Search";
import Chats from "./pages/Chats";
import Creator from "./pages/Creator";
import User from "./pages/User";
import Admin from "./pages/Admin";
import ContactUs from "./pages/Contactus";
import Maintenance from "./pages/Maintenance";
import Campaigns from "./pages/Campaigns";
import Finance from "./pages/Finance";
import MediaKit from "./pages/MediaKit";
import { TermsOfUse, PrivacyPolicy } from "./pages/Legal";
import { LanguageProvider } from './LanguageContext';
import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';

const MAINTENANCE_MODE = false;

/**
 * Hands `api.js` the router's own `navigate`, so the interceptor can bounce a
 * dead session to the landing page without reloading the document.
 *
 * Renders nothing, and has to live *inside* `BrowserRouter` — `useNavigate`
 * has no router above it anywhere else.
 */
function ApiNavigator() {
  const navigate = useNavigate();
  useEffect(() => {
    setApiNavigator(navigate);
    return () => setApiNavigator(null);
  }, [navigate]);
  return null;
}

function Logout() {
  localStorage.clear()
  return <Navigate to="/" />
}

function App() {
  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      const addListeners = async () => {
        await PushNotifications.addListener('registration', async token => {
          console.info('Push Notification Token: ', token.value);
          try {
            const access = localStorage.getItem("access");
            if (access) {
              await api.post("/api/fcm/register/", { fcm_token: token.value });
            }
          } catch (e) {
            console.error("FCM Token kayıt hatası:", e);
          }
        });

        await PushNotifications.addListener('registrationError', err => {
          console.error('Registration error: ', err.error);
        });

        await PushNotifications.addListener('pushNotificationReceived', notification => {
          console.log('Push notification received: ', notification);
          // TODO: Uygulama açıkken bildirim gelirse UI üzerinde gösterebilirsiniz
        });

        await PushNotifications.addListener('pushNotificationActionPerformed', notification => {
          console.log('Push notification action performed', notification.actionId, notification.inputValue);
        });
      };

      const registerNotifications = async () => {
        let permStatus = await PushNotifications.checkPermissions();

        if (permStatus.receive === 'prompt') {
          permStatus = await PushNotifications.requestPermissions();
        }

        if (permStatus.receive !== 'granted') {
          console.error('Kullanıcı bildirim iznini reddetti!');
          return;
        }

        await PushNotifications.register();
      };

      addListeners();
      registerNotifications();
    }
  }, []);

  if (MAINTENANCE_MODE) {
    return <Maintenance />;
  }

  return (
    <LanguageProvider>
      <BrowserRouter>
        <ApiNavigator />
        <Routes>

          <Route path="/settings" element={<ProtectedRoute><UserProvider><Settings /></UserProvider></ProtectedRoute>} />
          {/* <Route path="/home" element={<ProtectedRoute><UserProvider><Home /></UserProvider></ProtectedRoute>} /> */}
          <Route path="/search" element={<ProtectedRoute><UserProvider><Search /></UserProvider></ProtectedRoute>} />
          <Route path="/campaigns" element={<ProtectedRoute><UserProvider><Campaigns /></UserProvider></ProtectedRoute>} />
          <Route path="/finance" element={<ProtectedRoute><UserProvider><Finance /></UserProvider></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><UserProvider><Profile /></UserProvider></ProtectedRoute>} />
          <Route path="/creator" element={<ProtectedRoute><UserProvider><Creator /></UserProvider></ProtectedRoute>} />
          <Route path="/chats" element={<ProtectedRoute><UserProvider><Chats /></UserProvider></ProtectedRoute>} />
          <Route path="/" element={<Landing />} />
          <Route path="/contactus" element={<ContactUs />} />

          {/* Public and unauthenticated on purpose: the sign-up dialog links to
              both, and someone deciding whether to agree has to be able to read
              them before they have an account. Registered ahead of the
              `/:username` catch-all, which would otherwise swallow them. */}
          <Route path="/termsofuse" element={<TermsOfUse />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />

          {/* Login and sign-up are dialogs over the landing page, not screens of
              their own — these two paths still exist because they are linked
              from mail and from old bookmarks, so they land on the page rather
              than 404. They no longer open the dialog on arrival: the visitor
              opens it from the header when they want it. `pages/Register` is
              kept as the standalone fallback it always was. */}
          <Route path="/login" element={<Landing />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/register" element={<Landing />} />
          <Route path="/register/classic" element={<Register />} />
          <Route path="/reset_password" element={<ForgetPassword />} />
          {/* Public like the profile below it — a press page a brand can open
              from an email without an account. Registered ahead of the
              catch-all so the two-segment path is never swallowed by it. */}
          <Route path="/:username/media-kit" element={<MediaKit />} />
          <Route path="/:username" element={<User />} />
          <Route path="/manage/admin" element={<Admin />} />

        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  )
}
export default App